<template>
	<div>
		<CRow>
			<CCol xs="12" lg="12">
				<CCard>
					<CCardHeader>
						<div class="row">
							<CCol sm="6" class="align-self-center">
								<strong>{{ $lang.resume_template_plan.crud.edit }}</strong>
							</CCol>
						</div>
					</CCardHeader>
					<CCardBody>
						<CAlert :color="messageColor" closeButton :show.sync="dismissCountDown" fade>
							{{ err_msg }}
						</CAlert>
						<CForm @submit.prevent="onResumeTemplatePlanSubmit">
							<CRow>
								<CCol md="4">
									<div class="form-group">
										<label class="form__label">{{ $lang.resume_template_plan.form.name }}
	                      <required_span/>
	                    </label>
										<input type="text" :maxlength="maxlength.name" :placeholder="$lang.resume_template_plan.form.name" class="form-control" v-model="resume_template_plan.name" />
										<small class="error" v-if="$v.resume_template_plan.$error && !$v.resume_template_plan.name.required">{{
	                        $lang.resume_template_plan.validation.required.name
	                      }}</small>
									</div>
								</CCol>
								<CCol md="4">
                                    <div class="form-group">
                                        <label class="form__label">{{ $lang.resume_template_plan.form.skuCodeAndroid }}</label>
                                        <input type="text" :maxlength="maxlength.skuCode" placeholder="Android SKU Code" class="form-control" v-model="resume_template_plan.skuCodeAndroid" />
                                    </div>
                                </CCol>

                                <CCol md="4">
                                    <div class="form-group">
                                        <label class="form__label">{{ $lang.resume_template_plan.form.skuCodeIos }}</label>
                                        <input type="text" :maxlength="maxlength.skuCode" placeholder="iOS SKU Code" class="form-control" v-model="resume_template_plan.skuCodeIos" />
                                    </div>
                                </CCol>
	
								<CCol md="4">
									<div class="form-group">
										<label class="form__label">{{ $lang.resume_template_plan.form.type }} <required_span/> </label>
										<v-select id="type" :options="typeOptions" v-model="resume_template_plan.type"></v-select>
										<small class="error" v-if="$v.resume_template_plan.$error && !$v.resume_template_plan.type.required">{{
                                            $lang.resume_template_plan.validation.required.type
                                        }}</small>
									</div>
								</CCol>
								<CCol md="4">
									<div class="form-group">
										<label class="form__label">{{ $lang.resume_template_plan.form.fontStyle }} <required_span/> </label>
										<v-select id="fontStyle" :options="fontStyleOptions" v-model="resume_template_plan.fontStyle"></v-select>
										<small class="error" v-if="$v.resume_template_plan.$error && !$v.resume_template_plan.fontStyle.required">
                                            {{ $lang.resume_template_plan.validation.required.fontStyle }}
                                        </small>
									</div>
								</CCol>
								<CCol md="4">
									<div class="form-group">
										<label class="form__label">{{ $lang.resume_template_plan.form.fontSize }} <required_span/> </label>
										<v-select id="fontSize" :options="fontSizeOptions" v-model="resume_template_plan.fontSize"></v-select>
										<small class="error" v-if="$v.resume_template_plan.$error && !$v.resume_template_plan.fontSize.required">
                                            {{ $lang.resume_template_plan.validation.required.fontSize }}
                                        </small>
									</div>
								</CCol>
                                <!-- <CCol md="4">
									<div class="form-group">
										<label class="form__label">{{ $lang.resume_template_plan.form.color }} <required_span/> </label>
										<input type="color" :placeholder="$lang.resume_template_plan.form.color" class="form-control" v-model="resume_template_plan.color" />
										<small class="error" v-if="$v.resume_template_plan.$error && !$v.resume_template_plan.color.required">
                                            {{ $lang.resume_template_plan.validation.required.color }}
                                        </small>
									</div>
								</CCol> -->

                                <CCol md="4">
                                    <div class="form-group">
                                        <label class="form__label">Is Free? </label><br>
                                        <input type="checkbox" :placeholder="$lang.resume_template_plan.form.isFree" :value="0" @change="changedIsFree"
                                            v-model="resume_template_plan.isFree"/>
                                    </div>
                                </CCol>
								
								<CCol md="12">
									<div class="form-group">
										<label class="form__label">{{ $lang.resume_template_plan.form.description }} <required_span/> </label>
										<textarea :maxlength="maxlength.description" :placeholder="$lang.resume_template_plan.form.description" class="form-control" v-model="resume_template_plan.description" rows="5" />
										<small class="error" v-if="$v.resume_template_plan.$error && !$v.resume_template_plan.description.required">{{
                                            $lang.resume_template_plan.validation.required.description
                                        }}</small>
									</div>
								</CCol>
							</CRow>
							<span id="plan_pricing">
								<h4>Plan Price</h4>

								<div v-for="(platformInputs, platformKey) in inputs" :key="platformKey">
									<h5 class="mt-3 text-capitalize">{{ platformKey }}</h5>
									<div v-for="input in platformInputs" :key="input.id" class="inputArea">
										<CRow>
											<CCol md="3">
												<div class="form-group">
													<label class="form__label">{{ $lang.resume_template_plan.form.country }} </label>
													<v-select v-model="input.countryId" :options="countryOptions"></v-select>
												</div>
											</CCol>
											<CCol md="3">
												<div class="form-group">
													<label class="form__label">{{ $lang.resume_template_plan.form.price }} </label>
													<input type="text" v-model="input.price" class="form-control" :placeholder="$lang.resume_template_plan.form.price">
												</div>
											</CCol>
											<CCol md="3">
												<div class="form-group">
													<label class="form__label">{{ $lang.resume_template_plan.form.offerPrice }} </label>
													<input type="text" v-model="input.offerPrice" class="form-control" :placeholder="$lang.resume_template_plan.form.offerPrice">
												</div>
											</CCol>
											<CCol md="1">
												<div class="form-group">
													<label class="form__label">Has GST? </label><br>
													<input type="checkbox" v-model="input.hasGst"/>
												</div>
											</CCol>
											<CCol md="2">
												<div class="form-group">
													<label class="form__label">Actions</label><br>
													<button type="button" class="btn btn-success" @click="addInput(platformKey)">
														<i class="fa fa-plus"></i>
													</button>&nbsp;
													<button type="button" class="btn btn-danger" @click="subInput(platformKey, input.id)">
														<i class="fa fa-minus"></i>
													</button>
												</div>
											</CCol>
										</CRow>
									</div>
								</div>
							</span>

						</span>
							
                        <CRow>
                            <CCol col="6" class="text-left">
                                <CButton color="primary" :disabled="submitted" class="px-4" type="submit">
                                    {{ $lang.common.general.submit }}
                                </CButton>
                            </CCol>
                        </CRow>
						</CForm>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
	</div>
</template>

<script>
import $ from "jquery";
import Vue from "vue";
import VueForm from "vue-form";
import { ServerTable } from "vue-tables-2";
import { required, requiredIf } from "vuelidate/lib/validators";
import required_span from "../../components/layouts/general/required-span";
import { Maxlength } from "../../store/maxlength";
import { Mixin } from "/src/mixins/index.js";
import store from "/src/store/store.js";
import { country, resumeTemplatePlan } from "/src/store/url.js";
import options from "/src/validations/validations.js";

Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);
export default {
	name: "ResumeCreatePlan",
	mixins: [Mixin],
	components: {
		required_span,
	},
	data() {
		return {
			maxV: '',
			counter: 0,
			menuCounter: 0,
			sideMenuCounter: 0,
			messageColor: "",
			submitted: false,
			err_msg: "",
			showAlert: false,
			dismissCountDown: 0,
			self: this,
			moduleCountry: country,
			module: resumeTemplatePlan,
			msg: "",
			typeOptions: [{
					'id': 'Company',
					'label': 'Company',
				},
				{
					'id': 'People',
					'label': 'DirectCandidate',
				},
                {
					'id': 'HRAgency',
					'label': 'HR Agency',
				},
			],
			platformOptions: [{
					'id': 0,
					'label': 'Web',
				},
				{
					'id': 1,
					'label': 'Android',
				},
				{
					'id': 2,
					'label': 'IOS',
				},
			],
            fontStyleOptions: [
                { id: 'arial', label: 'Arial' },
                { id: 'times-new-roman', label: 'Times New Roman' },
                { id: 'verdana', label: 'Verdana' },
                { id: 'georgia', label: 'Georgia' },
                { id: 'courier-new', label: 'Courier New' },
            ],
            fontSizeOptions:[
            {
	            'id': '10',
	            'label': '10',
	            },
	            {
	            'id': '11',
	            'label': '11',
	            },
	            {
	            'id': '12',
	            'label': '12',
	            },
	            {
	            'id': '13',
	            'label': '13',
	            },
	            {
	            'id': '14',
	            'label': '14',
	            },
	            {
	            'id': '15',
	            'label': '15',
	            },
	            {
	            'id': '16',
	            'label': '16',
	            },
	            {
	            'id': '17',
	            'label': '17',
	            },
	            {
	            'id': '18',
	            'label': '18',
	            },
	            {
	            'id': '19',
	            'label': '19',
	            },
	            {
	            'id': '20',
	            'label': '20',
	            },
	        ],
			countryOptions: [],
			resume_template_plan: {
				name: "",
                skuCodeAndroid: "",
                skuCodeIos: "",
				type: "",
				description: "",
				status: 1,
			},
            inputs: {
				web: [{
					id: 'web_country0',
					price: '',
					offerPrice: '',
					hasGst: '',
					countryId: '',
				}],
				android: [{
					id: 'android_country0',
					price: '',
					offerPrice: '',
					hasGst: '',
					countryId: '',
				}],
				ios: [{
					id: 'ios_country0',
					price: '',
					offerPrice: '',
					hasGst: '',
					countryId: '',
				}],
			},
			maxlength: {
				name: Maxlength.resumePlan.name,
				description: Maxlength.resumePlan.description,
				price: Maxlength.resumePlan.price,
				offerPrice: Maxlength.resumePlan.offerPrice
			},
		};
	},
	validations: {
		resume_template_plan: {
			type: {
				required,
			},
			name: {
				required,
			},
			description: {
				required,
			},
            // color: {
			// 	required
			// },
            fontSize: {
				required
			},
            fontStyle: {
				required
			},
		},
	},
	mounted() {
		let self = this;
		store.commit("showLoader", false); // Loader Off
		self.dismissCountDown = 0;
		this.$root.$on("alert", (arg1, arg2) => {});
		if (localStorage.getItem("showAlert") !== "") {
			this.setAlert(true);
		}
		this.setAlert(false);
		localStorage.setItem("showAlert", "");
		axios.get('/countries/lists').then((response) => {
			response.data.data.map(function(value, key) {
				self.countryOptions.push({ value: value.id, label: value.name });
			});
		});

        const id = this.$route.params.id;
        axios.get(this.viewUrlApi(this.module, id)).then((response) => {
			const plan = response.data.data;

            // Map main plan fields
            this.resume_template_plan = {
                name: plan.title,
                skuCodeAndroid: plan.skuCodeAndroid || "",
                skuCodeIos: plan.skuCodeIos || "",
                type: { 
                    id: plan.type, 
                    label: plan.type === "DirectCandidate" ? "DirectCandidate" : 
                        plan.type === "HRAgency" ? "HR Agency" : 
                        "Company" 
                },
                description: plan.description,
                // color: plan.color || "",
                fontStyle: this.fontStyleOptions.find(f => f.id === plan.fontStyle) || null,
                fontSize: this.fontSizeOptions.find(f => f.id == plan.fontSize) || null,
                isFree: plan.isFree === 1 ? true : false,
            };

            if (plan.isFree) {
                $('#plan_pricing').css('display', 'none');
            } else {
                $('#plan_pricing').css('display', 'block');
            }

            // Map prices for each platform
            plan.platforms.forEach(p => {
                const key = p.platform == 0 ? 'web' : p.platform == 1 ? 'android' : 'ios';
                
                // If prices exist, map them; otherwise keep default empty input
                if (p.prices && p.prices.length > 0) {
                    this.inputs[key] = p.prices.map((price, idx) => {
                        const countryObj = this.countryOptions.find(c => c.value === price.currencyId);
                        return {
                            id: `${key}_country${idx}`,
                            countryId: countryObj || { value: price.currencyId, label: `ID: ${price.currencyId}` },
                            price: price.price,
                            offerPrice: price.offerPrice,
                            hasGst: price.hasGst ? 1 : 0,
                        };
                    });
                }
                // else: keep the default empty input from data() initialization
            });
        }).catch((error) => {
        console.error("Failed to fetch list", error);
        this.userOptions = [];
    });
	},
	watch: {
		$route: {
			immediate: true,
			handler(route) {
				if (route.query && route.query.page) {
					this.activePage = Number(route.query.page);
				}
			},
		},
	},
	methods: {
        changedIsFree(e) {
            let self = this;
            this.v = e.target.checked;
            if (this.v) {
                self.resume_template_plan.is_free = 1;
                $('#plan_pricing').css('display', 'none');
            } else {
                self.resume_template_plan.is_free = 0;
                $('#plan_pricing').css('display', 'block');
            }
        },
		changedHasGST(e) {
			let self = this;
			this.v = e.target.checked;
			if (this.v) {
				self.resume_template_plan.hasGst = 1;
			} else {
				self.resume_template_plan.hasGst = 0;
			}
		},
		addInput(platformKey) {
			this.inputs[platformKey].push({
				id: `${platformKey}_country${this.inputs[platformKey].length}`,
				price: '',
				offerPrice: '',
				hasGst: '',
				countryId: '',
			});
		},
		subInput(platformKey, id) {
			const index = this.inputs[platformKey].findIndex(i => i.id === id);
			if (index > 0) this.inputs[platformKey].splice(index, 1);
		},
		onResumeTemplatePlanSubmit() {
			let self = this;
			this.$v.resume_template_plan.$touch();
			if (this.$v.resume_template_plan.$invalid) {
				self.submitted = false; //Enable Button
				this.submitStatus = "ERROR";
			} else {
				let self = this;
				self.submitted = true; //Disable Button
				let postData;

                // If plan is free, send empty priceDetail array
                const priceDetail = self.resume_template_plan.isFree 
                ? [] 
                : Object.keys(this.inputs).flatMap((platformKey) =>
                    this.inputs[platformKey].map((i) => ({
                        platform: platformKey, // 'web' | 'android' | 'ios'
                        countryId: i.countryId,
                        price: i.price,
                        offerPrice: i.offerPrice,
                        isInclusive: 1,
                        gstId: i.hasGst ? 1 : null,
                        gstBusinessName: i.hasGst ? 'The Resourceful Network Private Limited' : null,
                        gstNumber: i.hasGst ? '24AAMCT8780H1ZS' : null,
                        hasGst: i.hasGst ? 1 : 0,
                    }))
                );


				postData = {
					"title": self.resume_template_plan.name,
					"skuCodeAndroid": self.resume_template_plan.skuCodeAndroid,
                    "skuCodeIos": self.resume_template_plan.skuCodeIos,
					"type": self.resume_template_plan.type,
					"fontStyle": self.resume_template_plan.fontStyle,
					"fontSize": self.resume_template_plan.fontSize,
					// "color": self.resume_template_plan.color,
					"isFree": self.resume_template_plan.isFree,
					"description": self.resume_template_plan.description,
					"isActive": self.resume_template_plan.status,
					"priceDetail": priceDetail
				}
                const editId = this.$route.params.id;
                axios.post(self.editUrlApi(self.module, editId), postData).then((response) => {
                    self.submitted = false; //Enable Button
                    store.commit("showLoader", false); // Loader Off
                    if (response.data.code == 200) {
                        self.err_msg = response.data.message;
                        localStorage.setItem("notificationType", "success");
                        localStorage.setItem(
                            "notificationMessage",
                            response.data.message
                        );
                        this.$router.push({ name: "Resume Template Plan" });
                        self.dismissCountDown = 10;
                        self.messageColor = "success";
                    } else {
                        self.err_msg = response.data.message;
                        self.messageColor = "danger";
                        self.dismissCountDown = 10;
                    }
                })
                .catch(function(error) {
                    let data;
                    if (error.response.data.error) {
                        data = error.response.data.error.toString();
                    } else {
                        data = error.response.data.message;
                    }
                    self.err_msg = data;
                    self.dismissCountDown = 10;
                    self.messageColor = "danger";
                    self.submitted = false; //Enable Button
                });
            }
		},
		setAlert(value) {
			this.showAlert = value;
		},
	},
};
</script>

<style>
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	margin-top: 60px;
}
</style>
